import React from 'react'
import LayoutMain from '../layouts/Main'
import LayoutBase from '../layouts/Base'
import Reports from '../components/Reports'

export default function ReportsPage() {
  return (
    <LayoutBase>
      <LayoutMain>
        <Reports />
      </LayoutMain>
    </LayoutBase>
  )
}
